export default __webpack_public_path__ + "static/media/flagSpecial0.41aa91e9.svg";